import React, { useState, useEffect, useRef } from "react";

import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import DefaultImage from "../../../assets/images/icons/sampleimage.jpg";
import PieChart from "../jewelry/PieChart";
import { Pie, getElementAtEvent } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ReportJewelryReportService from "../../../services/reports-Jewelry-service";
import moment from "moment";
import { Button, DatePicker, Modal, Select, Spin, Table, Tooltip } from "antd";
import Chart from "react-google-charts";
import { chartColors } from "../colors";

const { RangePicker } = DatePicker;
const initialEventState = {
  dealerID: "",
  forDealer: "",
  dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
  dataRangeTo: moment().format("YYYY-MM-DD"),
  retailerIds: [],
  vendorIds: [],
  category: "",
  vendor: "",
  retailer: "",
  price: "",
  price1: "",
  price2: "",
};

const JeweleryChartReports = () => {
  const { t } = useTranslation();
  const JewelRetailerMetalRef = useRef();
  const JewelRetailerMetalRef1 = useRef();
  const JewelRetailerMetalRef2 = useRef();

  const { Option } = Select;

  const [vendorList, setVendorList] = useState([]);
  const [retailerList, setRetailerList] = useState([]);
  const [topRetailerDealer, setTopRetailerDealer] = useState([]);
  const [topRetailerTotal, setTopRetailerTotal] = useState([]);
  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [selectedData, setSelectedData] = useState(initialEventState);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [countColumnData, setCountColumnData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [categoryColumnData, setCategoryColumnData] = useState([]);
  const [countCategoryColumnData, setCountCategoryColumnData] = useState([]);
  const [topVendorDealer, setTopVendorDealer] = useState([]);
  const [topVendorTotal, setTopVendorTotal] = useState([]);
  const [totalValueForPercentage, setTotalValueForPercentage] = useState(0);
  const [retailerTotalValuePercentage, setRetailerTotalValuePercentage] =
    useState(0);
  const [vendorTotalValuePercentage, setVendorTotalValuePercentage] =
    useState(0);
  const [key, setKey] = useState(true);
  const [dealerMembershipType, setDealerMembershiptype] = useState("");
  const [sortOrderType, setsortOrderType] = useState("desc");
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [JewelryChartReportsTableList, setJewelryChartReportsTableList] =
    useState([]);
  const [pageSize, setPageSize] = useState(15);
  const [pageNo, setPageNo] = useState(1);
  const [visible, setVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState();
  const [defaultVisible, setDefaultVisible] = useState(false);
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);
  const [dealerMemberTypeName, setDealerMemberTypeName] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [categoryIdData, setCategoryIdData] = useState([]);
  const [vendorIdData, setVendorIdData] = useState([]);
  const [retailerIdData, setRetailerIdData] = useState([]);
  const [TooltipPercentage, setTooltipPercentage] = useState("");

  // New states for processed chart data
  const [categoryChartData, setCategoryChartData] = useState([]);
  const [categoryColorData, setCategoryColorData] = useState([]);
  const [vendorChartData, setVendorChartData] = useState([]);
  const [vendorColorData, setVendorColorData] = useState([]);
  const [retailerChartData, setRetailerChartData] = useState([]);
  const [retailerColorData, setRetailerColorData] = useState([]);

  // Price chart states
  const [priceChartData, setPriceChartData] = useState([]);
  const [priceColorData, setPriceColorData] = useState([]);
  const [priceRange, setPriceRange] = useState([]);
  const [topPriceTotal, setPriceTotal] = useState([]);
  const [priceTotalValuePercentage, setPriceTotalValuePercentage] = useState(0);
  const [showPriceChart, setShowPriceChart] = useState(false);
  const [showPriceLoader, setShowPriceLoader] = useState(false);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum entries to show

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerMemberTypeName(
            loginDetials.loginDetials.responseData.dealerMemberTypeName
          );
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetForDealer(loginDetials.loginDetials.responseData.dealerId);
          setDealerMembershiptype(
            loginDetials.loginDetials.responseData.dealerMemberTypeName
          );
        }
      }
    }
    handleGetVendorDropdownData();
    handleGetRetailerDropdownData();
  }, []);
  useEffect(() => {
    if (selectedData.category || selectedData.vendor || selectedData.retailer || selectedData.price1 || selectedData.price === "Call For Price") {
      handleGetTableChartData(
        dealerId,
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName === "Vendor" ||
          loginDetials?.loginDetials?.responseData?.dealerMemberTypeName === "VendorDiamond"
          ? 1
          : loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
            "Retailer" ||
            loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
            "Combined"
            ? 2
            : 3,
        1,
        15,
        "",
        sortOrderType
      );
    }
  }, [selectedData]);

  // Process chart data with max entries limit
  const processChartData = (labels, values, dataType) => {
    if (!labels?.length || !values?.length) {
      return { chartData: [], colors: [] };
    }

    // Create data array with labels and values
    const dataWithValues = labels.map((label, index) => ({
      label,
      value: values[index],
      originalIndex: index,
    }));

    // Filter out zero values and sort by value (descending)
    const filteredData = dataWithValues.filter((item) => item.value > 0);
    const sortedData = [...filteredData].sort((a, b) => b.value - a.value);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce(
      (sum, item) => sum + item.value,
      0
    );
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        label: t("Others"),
        value: othersValue,
        isOthers: true,
      });
    }

    // Calculate total for percentages
    const total = topData.reduce((sum, item) => sum + item.value, 0);

    // Prepare chart data
    const processedChartData = [[dataType, "Count"]];
    const colors = [];

    topData.forEach((item, index) => {
      const percentage =
        total > 0 ? ((item.value / total) * 100).toFixed(1) : 0;
      const color = item.isOthers
        ? "#CCCCCC"
        : chartColors[index % chartColors.length];
      colors.push(color);

      processedChartData.push([`${item.label}`, item.value]);
    });

    return { chartData: processedChartData, colors };
  };

  const handleGetForDealer = (id) => {
    try {
      const inputData = {
        dealerID: id,
      };
      setShowLoader(true);
      ReportJewelryReportService.GetForDealer(inputData).then((response) => {
        
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          let forDealerValue;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
            "Vendor" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
            "VendorDiamond"
          ) {
            forDealerValue = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
            "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
            "Combined"
          ) {
            forDealerValue = 2;
          } else {
            forDealerValue = 3;
          }

          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
          handleGetTableChartData(id, forDealerValue);
          handleGetClicksBasedOnCategory(id, forDealerValue);
          handleGetTopRetailerCoulmnData(id,  forDealerValue);
          handleGetClicksBasedOnVendor(id, forDealerValue);
          handleGetClicksBasedOnPrice(id, forDealerValue);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetClicksBasedOnPrice = (DealerId, forDealerId) => {
    try {
      let inputData = {
        dealerID: DealerId.toString(),
        forDealer: forDealerId.toString(),
        fromDate: selectedData.dataRangeFrom
          ? moment(selectedData.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: selectedData.dataRangeTo
          ? moment(selectedData.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: getIdsForApi(selectedData.retailerIds),
        vendorIds: getIdsForApi(selectedData.vendorIds),
        reporttype: "Dealer",
      };
      setShowPriceLoader(true);
      console.log("Calling GetClicksBasedOnPrice with:", inputData);
      ReportJewelryReportService.GetClicksBasedOnPrice(inputData).then(
        (response) => {
          console.log("GetClicksBasedOnPrice response:", response.data);
          let message = response.data.message;
          let responseData = response.data.responseData?.Table || [];
          if (message === "Success" && responseData.length > 0) {
            let priceRangeData = [];
            let total = [];
            let showResp = responseData.every((element) => {
              return element.total === "0";
            });
            setShowPriceChart(showResp);
            for (let i of responseData) {
              if (Number(i.total) !== 0) {
                priceRangeData.push(i.Range);
                total.push(Number(i.total));
              }
            }

            let totalValuePercentage = total.reduce(
              (a, b) => (a = Number(a) + Number(b)),
              0
            );
            setPriceTotalValuePercentage(totalValuePercentage);
            setPriceTotal(total);
            setPriceRange(priceRangeData);

            // Process data for price chart
            const { chartData: processedData, colors } = processChartData(
              priceRangeData,
              total,
              "Price Range"
            );
            setPriceChartData(processedData);
            setPriceColorData(colors);
          } else {
            setPriceChartData([]);
            setPriceColorData([]);
            setShowPriceChart(true);
          }
          setShowPriceLoader(false);
        }
      ).catch((error) => {
        console.log(error);
        setShowPriceLoader(false);
      });
    } catch (error) {
      console.log(error);
      setShowPriceLoader(false);
    }
  };

  const handleGetVendorDropdownData = () => {
    try {
      const dealerId = loginDetials.loginDetials.responseData.dealerId;
      let inputData = {
        dealerId: dealerId,
        reporttype: "Dealer",
      };
      ReportJewelryReportService.GetVendorDropdownList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setVendorList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetRetailerDropdownData = () => {
    try {
      const dealerId = loginDetials.loginDetials.responseData.dealerId;
      let inputData = {
        dealerId: dealerId,
        reporttype: "Dealer",
      };
      ReportJewelryReportService.GetRetailerDropdownList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setRetailerList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const changeRetailerListHandler = (data) => {
    try {
      data = data.toString();
      let inputData = {
        vendorIds: data,
      };
      ReportJewelryReportService.ChangeRetailerList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setRetailerList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const changeVendorListHandler = (data) => {
    try {
      data = data.toString();
      let inputData = {
        retailerIds: data,
      };
      ReportJewelryReportService.ChangeVendorList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setVendorList(responseData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnChange = (e, isSelect, name) => {
    const getDealerId = (value) => {
      if (value === 0 || value === "0") return "0";
      if (typeof value === "string" && value.includes("|")) {
        return value.split("|")[0];
      }
      return value.toString();
    };
    const hasAllSelected = (arr) => arr.some(val => getDealerId(val) === "0");

    if (isSelect === "select" && name === "vendors") {
      let vId = "";
      if (hasAllSelected(e)) {
        vId = e.filter(val => getDealerId(val) === "0");
        setSelectedData((prevState) => ({
          ...prevState,
          vendorIds: vId,
        }));
      } else {
        vId = e;
        setSelectedData((prevState) => ({
          ...prevState,
          vendorIds: e,
        }));
      }

      if (e.length === 0 || hasAllSelected(e)) {
        handleGetVendorDropdownData();
        handleGetRetailerDropdownData();
      } else {
        const dealerIds = extractDealerIds(vId);
        changeRetailerListHandler(dealerIds);
      }
    } else if (isSelect === "select" && name === "retailers") {
      let rId = "";
      if (hasAllSelected(e)) {
        rId = e.filter(val => getDealerId(val) === "0");
        setSelectedData((prevState) => ({
          ...prevState,
          retailerIds: rId,
        }));
      } else {
        rId = e;
        setSelectedData((prevState) => ({
          ...prevState,
          retailerIds: e,
        }));
      }

      if (e.length === 0 || hasAllSelected(e)) {
        handleGetVendorDropdownData();
        handleGetRetailerDropdownData();
      } else {
        const dealerIds = extractDealerIds(rId);
        changeVendorListHandler(dealerIds);
      }
    }
  };

  const handleGetTableChartData = (
    DealerId,
    forDealerId,
    pageNumber,
    pageSize,
    sortColumn,
    sorttype
  ) => {
    try {
      let inputData = {
        dealerID: DealerId.toString(),
        forDealer: forDealerId ? forDealerId.toString() : "",
        fromDate: selectedData.dataRangeFrom
          ? moment(selectedData.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: selectedData.dataRangeTo
          ? moment(selectedData.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: getIdsForApi(selectedData.retailerIds),
        vendorIds: getIdsForApi(selectedData.vendorIds),
        pageIndex: pageNumber ? pageNumber : 1,
        pageSize: pageSize ? pageSize : 15,
        category: selectedData.category,
        metalType: "",
        metalColorType: "",
        vendor: selectedData.vendor,
        retailer: selectedData.retailer,
        price: selectedData.price,
        price1: selectedData.price1 ? selectedData.price1.toString() : "",
        price2: selectedData.price2 ? selectedData.price2.toString() : "",
        sortColumnName:
          sortColumn === "UserIPAddress"
            ? "UserIPAddress"
            : sortColumn === "vendorName"
              ? "VendorName"
              : sortColumn === "retailerName"
                ? "RetailerName"
                : sortColumn === "collectionNew"
                  ? "CollectionNew"
                  : sortColumn === "category"
                    ? "Category"
                    : sortColumn === "date"
                      ? "Date"
                      : sortColumn === "styleNumber"
                        ? "StyleNumber"
                        : sortColumn === "metalType"
                          ? "MetalType"
                          : sortColumn === "metalColor"
                            ? "MetalColor"
                            : sortColumn === "price"
                              ? "Price"
                              : "date",
        sortOrder: sorttype ? sorttype.toString() : sortOrderType.toString(),
        reporttype: "Dealer",
      };
      setShowTableLoader(true);
      ReportJewelryReportService.GetJewelryTableChartData(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            setJewelryChartReportsTableList(responseData);
            setShowTableLoader(false);
            setTotalCount(responseData?.[0]?.totalRecords || 0);
          } else {
            setJewelryChartReportsTableList([]);
            setShowTableLoader(false);
          }
        })
        .catch((error) => {
          setShowTableLoader(false);
          console.log(error);
        });
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  const handleGetClicksBasedOnCategory = (DealerId, forDealerId) => {
    try {
      let inputData = {
        dealerID: DealerId.toString(),
        forDealer: forDealerId ? forDealerId.toString() : "",
        fromDate: selectedData.dataRangeFrom
          ? moment(selectedData.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: selectedData.dataRangeTo
          ? moment(selectedData.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: getIdsForApi(selectedData.retailerIds),
        vendorIds: getIdsForApi(selectedData.vendorIds),
        reporttype: "Dealer",
      };
      setShowLoader(true);
      ReportJewelryReportService.GetClicksBasedOnCategory(inputData).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData.Table;
          if (message === "Success") {
            let category = [];
            let count = [];
            for (let i of responseData) {
              category.push(i.Category);
              count.push(i.count);
            }
            let totalValuePercentage = count.reduce(
              (a, b) => (a = Number(a) + Number(b)),
              0
            );
            setCountCategoryColumnData(count);
            setCategoryColumnData(category);
            setCategoryIdData(category);
            setTotalValueForPercentage(totalValuePercentage);

            // Process data for category chart
            const { chartData: processedData, colors } = processChartData(
              category,
              count,
              "Category"
            );
            setCategoryChartData(processedData);
            setCategoryColorData(colors);

            setShowLoader(false);
            setKey(!key);
          } else {
            setShowLoader(false);
          }
        }
      );
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  const handleGetTopRetailerCoulmnData = (DealerId, forDealerId) => {
    try {
      let inputData = {
        dealerID: DealerId.toString(),
        forDealer: DealerId === 1785 ? '3' : forDealerId ? forDealerId.toString() : "",
        fromDate: selectedData.dataRangeFrom
          ? moment(selectedData.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: selectedData.dataRangeTo
          ? moment(selectedData.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: getIdsForApi(selectedData.retailerIds),
        vendorIds: getIdsForApi(selectedData.vendorIds),
        reporttype: "Dealer",
      };
      setShowLoader(true);
      ReportJewelryReportService.GetClicksBasedOnRetailer(inputData).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            let dealerName = [];
            let total = [];
            for (let i of responseData) {
              dealerName.push(i.dealerCompany);
              total.push(Number(i.total));
            }
            let totalValuePercentage = total.reduce(
              (a, b) => (a = Number(a) + Number(b)),
              0
            );

            setTopRetailerTotal(total);
            setTopRetailerDealer(dealerName);
            setRetailerIdData(dealerName);
            setRetailerTotalValuePercentage(totalValuePercentage);

            // Process data for retailer chart
            const { chartData: processedData, colors } = processChartData(
              dealerName,
              total,
              "Retailer"
            );
            setRetailerChartData(processedData);
            setRetailerColorData(colors);

            setShowLoader(false);
            setKey(!key);
          } else {
            setShowLoader(false);
          }
        }
      );
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  console.log(loginDetials.loginDetials.responseData.dealerMemberTypeName, 'Dealer Member Type Name')
  const handleGetClicksBasedOnVendor = (DealerId, forDealerId) => {
    try {
      let inputData = {
        dealerID: DealerId.toString(),
        forDealer:
          loginDetials.loginDetials.responseData.dealerMemberTypeName ===
            "Vendor"
            ? "1" :
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "Retailer" ? "2"
              : "3",
        fromDate: selectedData.dataRangeFrom
          ? moment(selectedData.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: selectedData.dataRangeTo
          ? moment(selectedData.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: getIdsForApi(selectedData.retailerIds),
        vendorIds: getIdsForApi(selectedData.vendorIds),
        reporttype: "Dealer",
      };
      setShowLoader(true);
      ReportJewelryReportService.GetClicksBasedOnTopVendor(inputData).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData.Table;
          if (message === "Success") {
            let dealerCompany = [];
            let total = [];
            for (let i of responseData) {
              dealerCompany.push(i.DealerCompany);
              total.push(i.Total);
            }

            let totalValuePercentage = total.reduce(
              (a, b) => (a = Number(a) + Number(b)),
              0
            );

            setTopVendorTotal(total);
            setTopVendorDealer(dealerCompany);
            setVendorIdData(dealerCompany);
            setVendorTotalValuePercentage(totalValuePercentage);

            // Process data for vendor chart
            const { chartData: processedData, colors } = processChartData(
              dealerCompany,
              total,
              "Vendor"
            );
            setVendorChartData(processedData);
            setVendorColorData(colors);

            setShowLoader(false);
            setKey(!key);
          } else {
            setShowLoader(false);
          }
        }
      );
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  const handleExportChartReportToCSV = (sortColumn, sorttype) => {
    try {
      let forDealerValue = "";
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "Vendor" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorDiamond"
      ) {
        forDealerValue = 1;
      } else if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "Retailer" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "Combined"
      ) {
        forDealerValue = 2;
      } else {
        forDealerValue = 3;
      }
      const inputData = {
        dealerId: dealerId.toString(),
        forDealer: forDealerValue.toString(),
        fromDate: selectedData.dataRangeFrom
          ? moment(selectedData.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: selectedData.dataRangeTo
          ? moment(selectedData.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        pageIndex: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        reporttype: "Dealer",
        retailerIds: getIdsForApi(selectedData.retailerIds),
        vendorIds: getIdsForApi(selectedData.vendorIds),
        sortColumnName:
          sortColumn === "UserIPAddress"
            ? "UserIPAddress"
            : sortColumn === "vendorName"
              ? "VendorName"
              : sortColumn === "retailerName"
                ? "RetailerName"
                : sortColumn === "collectionNew"
                  ? "CollectionNew"
                  : sortColumn === "category"
                    ? "Category"
                    : sortColumn === "date"
                      ? "Date"
                      : sortColumn === "styleNumber"
                        ? "StyleNumber"
                        : sortColumn === "metalType"
                          ? "MetalType"
                          : sortColumn === "metalColor"
                            ? "MetalColor"
                            : sortColumn === "price"
                              ? "Price"
                              : "date",
        sortOrder: "asc",
      };
      setDownloadCSVDataloading(true);
      ReportJewelryReportService.ExportChartReportToCSV(inputData)
        .then((response) => {
          setDownloadCSVDataloading(false);
          var fileName =
            loginDetials.loginDetials.responseData.dealerCompany.replace(/\s+/g, "") +
            "_JewelryChartReports_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
    }
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order === "descend") {
      type = "DESC";
      column = sorter.field;
      setsortOrderType(type);
    } else if (sorter.order === "ascend") {
      type = "ASC";
      column = sorter.field;
      setsortOrderType(type);
    } else {
      type = "DESC";
      column = "date";
      setsortOrderType(type);
    }
    console.log("Sort Type:", type);
    console.log("Sort Column:", column);
    const forDealerValue =
      loginDetials?.loginDetials?.responseData?.dealerMemberTypeName === "Vendor" ||
        loginDetials?.loginDetials?.responseData?.dealerMemberTypeName === "VendorDiamond"
        ? 1
        : loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "Retailer" ||
          loginDetials?.loginDetials?.responseData?.dealerMemberTypeName ===
          "Combined"
          ? 2
          : 3;
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetTableChartData(
      dealerId,
      forDealerValue,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };

  const handleApplyFilter = () => {
    setTopRetailerDealer([]);
    setTopRetailerTotal([]);
    setPriceChartData([]);
    setPriceColorData([]);
    setPageNo(1);
    setPageSize(15);
    handleGetForDealer(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };

  const imageClickHandler = (img) => {
    setVisible(true);
    setSelectedImage(img);
  };

  const extractDealerId = (value) => {
    if (value === 0 || value === "0") return "0";
    if (typeof value === "string" && value.includes("|")) {
      return value.split("|")[0];
    }
    return value.toString();
  };

  const extractDealerIds = (values) => {
    if (!values || values.length === 0) return [];
    return values.map(extractDealerId);
  };

  // Helper to get vendor/retailer IDs for API - returns empty string when "All" is selected
  const getIdsForApi = (ids) => {
    if (!ids || ids.length === 0) return "";
    const extractedIds = extractDealerIds(ids);
    // If "All" (0) is selected, return empty string so API returns all data
    if (extractedIds.some(id => id === "0")) return "";
    return extractedIds.toString();
  };

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setSelectedData((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };

  // Updated chart options
  const categoryOptions = {
    pieHole: 0,
    is3D: true,
    title: `Jewelry Clicks for ${loginDetials?.loginDetials?.responseData?.dealerCompany} (${dealerId})`,
    legend: {
      position: "none",
    },
    tooltip: { trigger: "focus" },
    pieSliceText: "percentage",
    chartArea: { width: "100%", height: "100%" },
    colors: categoryColorData,
  };

  const vendorOptions = {
    pieHole: 0,
    is3D: true,
    title: `Jewelry Clicks for ${loginDetials?.loginDetials?.responseData?.dealerCompany} (${dealerId})`,
    legend: {
      position: "none",
    },
    tooltip: { trigger: "focus" },
    pieSliceText: "percentage",
    chartArea: { width: "100%", height: "100%" },
    colors: vendorColorData,
  };

  const retailerOptions = {
    pieHole: 0,
    is3D: true,
    title: `Jewelry Clicks for ${loginDetials?.loginDetials?.responseData?.dealerCompany} (${dealerId})`,
    legend: {
      position: "none",
    },
    tooltip: { trigger: "focus" },
    pieSliceText: "percentage",
    chartArea: { width: "100%", height: "100%" },
    colors: retailerColorData,
  };

  const priceOptions = {
    pieHole: 0,
    is3D: true,
    title: `Jewelry Clicks for ${loginDetials?.loginDetials?.responseData?.dealerCompany} (${dealerId})`,
    legend: {
      position: "none",
    },
    tooltip: { trigger: "focus" },
    pieSliceText: "percentage",
    chartArea: { width: "100%", height: "100%" },
    colors: priceColorData,
  };

  const handleCategoryClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = categoryChartData[selectedItem.row + 1][0];
      const result = label.split(" (")[0];
      setSelectedData((prevState) => ({
        ...prevState,
        category: result,
      }));
      setPageNo(1);
    }
  };

  const handleVendorClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = vendorChartData[selectedItem.row + 1][0];
      const result = label.split(" (")[0];
      setSelectedData((prevState) => ({
        ...prevState,
        vendor: result,
        category: "",
        retailer: "",
      }));
      setPageNo(1);
    }
  };

  const handleRetailerClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = retailerChartData[selectedItem.row + 1][0];
      const result = label.split(" (")[0];
      setSelectedData((prevState) => ({
        ...prevState,
        retailer: result,
        vendor: "",
        category: "",
      }));
      setPageNo(1);
    }
  };

  const handlePriceClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = priceChartData[selectedItem.row + 1][0];
      const result = label.split(" (")[0];

      let low, high;

      if (result !== "Call For Price") {
        [low, high] = result.split("-");

        const lowPrice1 = parseInt(low.replace("$", ""));
        const highPrice2 = parseInt(high.replace("$", ""));

        setSelectedData((prevState) => ({
          ...prevState,
          price: "",
          price1: lowPrice1,
          price2: highPrice2,
          category: "",
          vendor: "",
          retailer: "",
        }));
      } else {
        setSelectedData((prevState) => ({
          ...prevState,
          price: "Call For Price",
          price1: "",
          price2: "",
          category: "",
          vendor: "",
          retailer: "",
        }));
      }

      setPageNo(1);
    }
  };

  // Custom Legend Component
  const CustomLegend = ({ chartData, colorData, title }) => (
    <div style={{ marginBottom: "20px" }}>
      {title && (
        <div
          style={{
            textAlign: "center",
            marginBottom: "10px",
            fontWeight: "bold",
          }}
        >
          {title}
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        {chartData.slice(1).map((row, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              margin: "4px 8px",
              fontSize: "13px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                width: "14px",
                height: "14px",
                backgroundColor: colorData[index],
                marginRight: "6px",
                borderRadius: "3px",
              }}
            ></div>
            {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Jewelry Chart Report")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block datepicker__block">
              <label> {t("Date Range")} </label>
              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>

          {dealerMembershipType === "Vendor" ||
            dealerMembershipType === "VendorDiamond" ? null : (
            <div className="col-md-4">
              <div className="input__block">
                <label> {t("Vendor(s)")} </label>
                <Select
                  className="border__grey"
                  showSearch
                  mode="multiple"
                  showArrow
                  placeholder={t("Select One or More Vendors")}
                  optionFilterProp="children"
                  value={selectedData.vendorIds}
                  onChange={(e) => handleOnChange(e, "select", "vendors")}
                >
                  {vendorList.map((item, key) => {
                    const uniqueValue = `${item.dealerID}|${item.dealerCompany}`;
                    return (
                      <Option key={`vendor-${key}-${item.dealerID}`} value={uniqueValue}>
                        {item.dealerCompany}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            </div>
          )}

          {dealerMembershipType === "Retailer" ? null : (
            <div className="col-md-4">
              <div className="input__block">
                <label> {t("Retailer(s)")} </label>
                <Select
                  showSearch
                  showArrow
                  className="border__grey"
                  placeholder={t("Select one or more retailer ")}
                  optionFilterProp="children"
                  onChange={(e) => handleOnChange(e, "select", "retailers")}
                  notFoundContent={t("No Data Found")}
                  mode="multiple"
                  value={selectedData.retailerIds}
                >
                  {retailerList.map((item, key) => {
                    const uniqueValue = `${item.dealerID}|${item.dealerCompany}`;
                    return (
                      <Option key={`retailer-${key}-${item.dealerID}`} value={uniqueValue}>
                        {item.dealerCompany}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            </div>
          )}

          <div className="col-md-4 mt-4">
            <div className="input__block">
              <button className="primary-btn mt-2" onClick={handleApplyFilter}>
                {t("Apply Filter")}
              </button>
            </div>
          </div>
          {/* {categoryColumnData.length > 0 &&
            topRetailerDealer.length > 0 &&
            topVendorDealer.length > 0 && ( */}
          <div className="col-lg-12 col-md-6">
            <div className="input__block">
              <label>
                {totalCount !== 0 && (
                  <b>
                    {t("Total Jewelry Clicks")} : {totalCount}
                  </b>
                )}
                <Tooltip
                  placement="right"
                  title={t(
                    "Displays the total number of jewelry clicks through the currently specified date range above"
                  )}
                >
                  <img src={UnionIcon} alt="img" />
                </Tooltip>
              </label>
            </div>
          </div>
          {/* )} */}
          <Spin spinning={showLoader}>
            <div className="col-lg-12">
              <label>
                <b> {t("Jewelry Clicks Based on Category")} </b>
              </label>
              <div
                className="chart__section"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {categoryChartData.length > 1 ? (
                  <>
                    <CustomLegend
                      chartData={categoryChartData}
                      colorData={categoryColorData}
                      title={t("Category Distribution")}
                    />
                    <div id="pdf-content">
                      <Chart
                        chartType="PieChart"
                        data={categoryChartData}
                        options={categoryOptions}
                        width={window.innerWidth > 500 ? 800 : 300}
                        height={window.innerWidth > 500 ? 500 : 300}
                        chartEvents={[
                          {
                            eventName: "select",
                            callback: handleCategoryClick,
                          },
                        ]}
                      />
                    </div>
                  </>
                ) : (
                  <div className="no-report-render">
                    <div className="desc-space">
                      <h4 className="text-center">{t("No Data Found")}</h4>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-12">
              <label>
                <b> {t("Jewelry Clicks Based on Price")} </b>
              </label>
              <Spin spinning={showPriceLoader}>
                <div
                  className="chart__section"
                  style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
                >
                  {!showPriceChart && priceChartData.length > 1 ? (
                    <>
                      <CustomLegend
                        chartData={priceChartData}
                        colorData={priceColorData}
                        title={t("Price Distribution")}
                      />
                      <div id="pdf-content-price">
                        <Chart
                          chartType="PieChart"
                          data={priceChartData}
                          options={priceOptions}
                          width={window.innerWidth > 500 ? 800 : 300}
                          height={window.innerWidth > 500 ? 500 : 300}
                          chartEvents={[
                            {
                              eventName: "select",
                              callback: handlePriceClick,
                            },
                          ]}
                        />
                      </div>
                    </>
                  ) : (
                    !showPriceLoader && (
                      <div className="no-report-render">
                        <div className="desc-space">
                          <h4 className="text-center">{t("No Data Found")}</h4>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </Spin>
            </div>

            {dealerMemberTypeName === "Admin" ? (
              <>
                <div className="col-lg-12">
                  <label>
                    <b> {t("Jewelry Clicks Based on Vendor")} </b>
                  </label>
                  <div className="chart__section">
                    {vendorChartData.length > 1 ? (
                      <>
                        <CustomLegend
                          chartData={vendorChartData}
                          colorData={vendorColorData}
                          title={t("Vendor Distribution")}
                        />
                        <div id="pdf-content2">
                          <Chart
                            chartType="PieChart"
                            data={vendorChartData}
                            options={vendorOptions}
                            width={window.innerWidth > 500 ? 800 : 300}
                            height={window.innerWidth > 500 ? 500 : 300}
                            chartEvents={[
                              {
                                eventName: "select",
                                callback: handleVendorClick,
                              },
                            ]}
                          />
                        </div>
                      </>
                    ) : (
                      <div className="no-report-render">
                        <div className="desc-space">
                          <h4 className="text-center">{t("No Data Found")}</h4>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-12">
                  <label>
                    <b> {t("Jewelry Clicks Based on Retailer")} </b>
                  </label>
                  <div className="chart__section">
                    {retailerChartData.length > 1 ? (
                      <>
                        <CustomLegend
                          chartData={retailerChartData}
                          colorData={retailerColorData}
                          title="Retailer Distribution"
                        />
                        <div id="pdf-content3">
                          <Chart
                            chartType="PieChart"
                            data={retailerChartData}
                            options={retailerOptions}
                            width={window.innerWidth > 500 ? 800 : 300}
                            height={window.innerWidth > 500 ? 500 : 300}
                            chartEvents={[
                              {
                                eventName: "select",
                                callback: handleRetailerClick,
                              },
                            ]}
                          />
                        </div>
                      </>
                    ) : (
                      <div className="no-report-render">
                        <div className="desc-space">
                          <h4 className="text-center">{t("No Data Found")}</h4>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : dealerMemberTypeName === "Retailer" ? (
              <div className="col-lg-12">
                <label>
                  <b> {t("Jewelry Clicks Based on Vendor")} </b>
                </label>
                <div
                  className="chart__section"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {vendorChartData.length > 1 ? (
                    <>
                      <CustomLegend
                        chartData={vendorChartData}
                        colorData={vendorColorData}
                        title={t("Vendor Distribution")}
                      />
                      <div id="pdf-content2">
                        <Chart
                          chartType="PieChart"
                          data={vendorChartData}
                          options={vendorOptions}
                          width={window.innerWidth > 500 ? 800 : 300}
                          height={window.innerWidth > 500 ? 500 : 300}
                          chartEvents={[
                            {
                              eventName: "select",
                              callback: handleVendorClick,
                            },
                          ]}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="no-report-render">
                      <div className="desc-space">
                        <h4 className="text-center">{t("No Data Found")}</h4>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="col-lg-12">
                <label>
                  <b> {t("Jewelry Clicks Based on Retailer")} </b>
                </label>
                <div className="chart__section">
                  {retailerChartData.length > 1 ? (
                    <>
                      <CustomLegend
                        chartData={retailerChartData}
                        colorData={retailerColorData}
                        title="Retailer Distribution"
                      />
                      <div id="pdf-content3">
                        <Chart
                          chartType="PieChart"
                          data={retailerChartData}
                          options={retailerOptions}
                          width={window.innerWidth > 500 ? 800 : 300}
                          height={window.innerWidth > 500 ? 500 : 300}
                          chartEvents={[
                            {
                              eventName: "select",
                              callback: handleRetailerClick,
                            },
                          ]}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="no-report-render">
                      <div className="desc-space">
                        <h4 className="text-center">{t("No Data Found")}</h4>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="col-lg-12 mt-3">
              <div className="options__div">
                <div className="row mb-4">
                  <div className="col-lg-10 rules__div"></div>
                  <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
                    <Button
                      className="primary-btn mb-2 mb-lg-0 mr-2"
                      onClick={() => handleExportChartReportToCSV()}
                      loading={downloadCSVDataloading}
                    >
                      <i className="fa fa-download"></i>
                      {t("Download CSV")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div className="table__scroll">
                <Table
                  className="pendjewelreq__tbl"
                scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
                  columns={[
                    {
                      title: (
                        <Tooltip title={t("Product Image")}>
                          {t("Product Image")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "imagePathNew",
                      render: (item, data) => (
                        <>
                          {data.imagePathNew ? (
                            <span
                              onClick={() =>
                                imageClickHandler(data.imagePathNew)
                              }
                            >
                              <img
                                src={data.imagePathNew}
                                alt="img"
                                className="product__img"
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          ) : (
                            <span onClick={() => setDefaultVisible(true)}>
                              <img
                                src={DefaultImage}
                                alt="img"
                                className="product__img"
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          )}
                        </>
                      ),
                    },
                    {
                      title: (
                        <Tooltip title={t("User IP Address")}>
                          {t("User IP Address")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "userIPAddress",
                      sorter: (a, b) => { },
                    },
                    ...(dealerMembershipType !== "Vendor" &&
                      dealerMembershipType !== "VendorDiamond"
                      ? [
                        {
                          title: (
                            <Tooltip title={t("Vendor")}>
                              {t("Vendor")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "vendorName",
                          sorter: (a, b) => { },
                        },
                      ]
                      : []),
                    ...(dealerMembershipType !== "Retailer"
                      ? [
                        {
                          title: (
                            <Tooltip title={t("Retailer")}>
                              {t("Retailer")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "retailerName",
                          sorter: (a, b) => { },
                        },
                      ]
                      : []),
                    {
                      title: (
                        <Tooltip title={t("Collection")}>
                          {t("Collection")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "collectionNew",
                      sorter: (a, b) => { },
                    },
                    {
                      title: (
                        <Tooltip title={t("Category")}>{t("Category")}</Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "category",
                      sorter: (a, b) => { },
                    },
                    {
                      title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "date",
                      defaultSortOrder: "descend",
                      sorter: (a, b) => { },
                      render: (row, item) => {
                        if (Object.keys(item.date).length !== 0) {
                          return (
                            <React.Fragment>
                              <span>
                                {moment(item.date).format(
                                  "MM-DD-YYYY, hh:mm:ss A"
                                )}
                              </span>
                            </React.Fragment>
                          );
                        }
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("Style Number")}>
                          {t("Style Number")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "styleNumber",
                      sorter: (a, b) => { },
                    },
                    {
                      title: (
                        <Tooltip title={t("Metal Type")}>
                          {t("Metal Type")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "metalType",
                      sorter: (a, b) => { },
                    },
                    {
                      title: (
                        <Tooltip title={t("Metal Color")}>
                          {t("Metal Color")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "metalColor",
                      sorter: (a, b) => { },
                    },
                    {
                      title: <Tooltip title={t("Price")}>{t("Price")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "price",
                      sorter: (a, b) => { },
                      render: (price) => (
                        <Tooltip title={price}>
                          <span>{price}</span>
                        </Tooltip>
                      ),
                    },
                  ]}
                  pagination={{
                    size: "small",
                    total: totalCount,
                    pageSizeOptions: [10, 15, 20, 50, 100],
                    responsive: true,
                    showSizeChanger: true,
                    pageSize: pageSize,
                    current: pageNo,
                  }}
                  loading={showTableLoader}
                  dataSource={JewelryChartReportsTableList}
                  onChange={handleTableASCDES}
                />
              </div>
            </div>
            <Modal
              title=""
              centered
              visible={visible}
              onOk={() => setVisible(false)}
              onCancel={() => setVisible(false)}
              width={500}
              footer={false}
              className="image-modal"
            >
              <div className="">
                <img src={selectedImage} alt="img" className="img-fluid" />
              </div>
            </Modal>

            <Modal
              title=""
              centered
              visible={defaultVisible}
              onOk={() => setDefaultVisible(false)}
              onCancel={() => setDefaultVisible(false)}
              width={500}
              footer={false}
            >
              <div className="">
                <img src={DefaultImage} alt="img" className="img-fluid" />
              </div>
            </Modal>
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default JeweleryChartReports;
